import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

export function PageHeader({ eyebrow, title, right, back }) {
  const navigate = useNavigate();
  return (
    <header className="px-5 pt-8 pb-5 flex items-end justify-between gap-4">
      <div className="min-w-0">
        {back && (
          <button
            data-testid="page-back-button"
            onClick={() => (window.history.length > 1 ? navigate(-1) : navigate("/journal"))}
            className="mb-3 -ml-3 h-11 pl-2 pr-4 rounded-full flex items-center gap-1 text-[15px] font-medium text-[#A1A1AA] hover:text-white active:bg-[#161618] transition-colors"
          >
            <ChevronLeft size={22} /> Back
          </button>
        )}
        {eyebrow && <div className="eyebrow mb-1.5">{eyebrow}</div>}
        <h1 className="font-display text-3xl font-bold uppercase tracking-tight leading-none truncate">{title}</h1>
      </div>
      {right}
    </header>
  );
}
